import { useState, useEffect } from "react";
import { Sun, Moon, Menu, X, User } from "lucide-react";
import { Link } from "react-router-dom";

import logoLight from "../assets/logo-black.png";
import logoDark from "../assets/logo-white.png";

import { useNavigate } from 'react-router-dom';


const Navbar = () => {
  const navigate = useNavigate();

  const [darkMode, setDarkMode] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("darkMode") === "true";
    }
    return false;
  });

  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("darkMode", darkMode.toString());
  }, [darkMode]);


  // Verifică dacă utilizatorul este conectat
  useEffect(() => {
    const checkAuthStatus = () => {
      const token = localStorage.getItem("token");
      const role = localStorage.getItem("role");
      setIsLoggedIn(!!token);
      setUserRole(role);
    };

    // Verifică la început
    checkAuthStatus();

    // Ascultă pentru schimbări în localStorage
    window.addEventListener('storage', checkAuthStatus);

    return () => {
      window.removeEventListener('storage', checkAuthStatus);
    };
  }, []);


  const toggleDarkMode = () => setDarkMode(!darkMode);

  // Funcție pentru a determina path-ul MY CABINET
  const getMyCabinetPath = () => {
    if (!isLoggedIn) return "/auth";
    return userRole === "admin" ? "/admin" : "/my-orders";
  };

  const getMyCabinetLabel = () => {
    return userRole === "admin" ? "ADMIN DASHBOARD" : "MY CABINET";
  };

  const navLinks = [
    { label: "ABOUT US", path: "/about-us" },
    { label: "GALLERY", path: "/gallery" },
    /*{ label: "ORDER PRODUCTS", path: "/orderproducts" },*/
    { label: "DROPBOX", path: "/dropbox" },
    { label: "CONTACT US", path: "/contact-us" },
  ];



  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [userRole, setUserRole] = useState<string | null>(null);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    setIsLoggedIn(false);
    setUserRole(null);
    navigate("/auth");
  };


  return (
    <>
      {/* Header with Logo and Dark Mode toggle */}
      <header className="flex flex-col items-center justify-center py-6 relative">
        <Link
          to="/"
          className="relative group p-4 transform transition duration-300 hover:scale-110"
          onClick={() => setMenuOpen(false)}
        >
          <div className="absolute inset-0 rounded-lg opacity-0 group-hover:opacity-100 transition duration-300 blur-md bg-[#025951]/30 pointer-events-none" />
          <img
            src={darkMode ? logoDark : logoLight}
            alt="FelixDent Logo"
            className="h-32 sm:h-40 md:h-48 lg:h-56 w-auto relative z-10 transition-transform duration-300 rounded"
          />
        </Link>

        <button
          onClick={toggleDarkMode}
          className="absolute right-6 top-6 transition"
          aria-label="Toggle dark mode"
        >
          {darkMode ? (
            <Sun size={36} className="text-white" />
          ) : (
            <Moon size={36} className="text-black" />
          )}
        </button>
      </header>

      {/* Navbar */}
      <nav
        className="bg-[#025951] text-white flex items-center justify-between px-4 md:px-8 py-3 relative"
        onMouseLeave={() => setMenuOpen(false)}
        onTouchEnd={() => setMenuOpen(false)}
      >
        {/* Mobile hamburger */}
        <div className="md:hidden flex items-center">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
            className="focus:outline-none z-30"
          >
            {menuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Desktop links */}
        <ul className="hidden md:flex md:gap-10 md:items-center md:flex-1 md:justify-center">
          {navLinks.map(({ label, path }) => (
            <li key={label}>
              <Link
                to={path}
                className="hover:underline hover:scale-105 transition-transform duration-200"
                onClick={() => setMenuOpen(false)}
              >
                {label}
              </Link>
            </li>
          ))}

          {/* MY CABINET / ADMIN DASHBOARD cu path dinamic */}
          <li>
            <Link
              to={getMyCabinetPath()}
              className="hover:underline hover:scale-105 transition-transform duration-200"
              onClick={() => setMenuOpen(false)}
            >
              {getMyCabinetLabel()}
            </Link>
          </li>

          {isLoggedIn && (
            <li>
              <button
                onClick={() => {
                  handleLogout();
                  setMenuOpen(false);
                }}
                className="hover:underline hover:scale-105 transition-transform duration-200 bg-transparent border-none text-white cursor-pointer"
              >
                Logout
              </button>
            </li>
          )}
        </ul>

        {/* Mobile menu dropdown */}
        <ul
          className={`md:hidden absolute top-full left-0 w-full bg-[#025951] flex flex-col transition-all duration-300 z-40 overflow-hidden ${menuOpen ? "max-h-96" : "max-h-0"}`}
        >
          {navLinks.map(({ label, path }) => (
            <li
              key={label}
              className="px-4 py-3 hover:underline hover:scale-105 transition-transform cursor-pointer text-center"
              onClick={() => setMenuOpen(false)}
            >
              <Link to={path}>{label}</Link>
            </li>
          ))}

          {/* MY CABINET / ADMIN DASHBOARD cu path dinamic */}
          <li
            className="px-4 py-3 hover:underline hover:scale-105 transition-transform cursor-pointer text-center"
            onClick={() => setMenuOpen(false)}
          >
            <Link to={getMyCabinetPath()}>{getMyCabinetLabel()}</Link>
          </li>

          {isLoggedIn && (
            <li
              className="px-4 py-3 hover:underline hover:scale-105 transition-transform cursor-pointer text-center"
              onClick={() => {
                handleLogout();
                setMenuOpen(false);
              }}
            >
              Logout
            </li>
          )}
        </ul>

        {/* MY CABINET icon (mobile) */}
        <div className="flex items-center md:hidden">
          <Link
            to={getMyCabinetPath()}
            className="flex items-center gap-2 hover:underline hover:scale-105 transition-transform cursor-pointer"
          >
            <User size={24} />
          </Link>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
